import { useEditorState, useChainedCommands } from '@remirror/react';
import markdownToHtml from './../utils/markdown-to-html';
import { htmlToProsemirrorNode } from '@remirror/core';
import { Fragment, Slice } from 'prosemirror-model';
import { useCallback } from 'react';

export const useApplyTransactionInRange = () => {
  const chain = useChainedCommands();
  const editorState = useEditorState();

  const deleteSelection = useCallback(() => {
    chain
      .focus()
      .customDispatch(({ tr, dispatch }) => {
        tr.deleteSelection();
        if (dispatch) dispatch(tr);
      })
      .run();
  }, [chain]);

  const updateContentInRange = useCallback(
    ({ from, content }) => {
      const htmlContent = markdownToHtml(content);
      const node = htmlToProsemirrorNode({
        content: htmlContent,
        schema: editorState.schema,
      });
      const slice = new Slice(Fragment.from(node), 0, 0);
      chain
        .focus()
        .customDispatch(({ tr, dispatch }) => {
          tr.insert(from > 1 ? from - 2 : from, slice.content);
          if (dispatch) dispatch(tr);
        })
        .run();
    },
    [editorState, chain]
  );

  return { updateContentInRange, deleteSelection };
};

export default useApplyTransactionInRange;
